export default "__VITE_ASSET__BquLrVD2__"